import { useEffect, useContext } from "react"
import PropTypes from "prop-types"

import { JourneyContext } from "../../../../../../../journey.context"

const Audit = ({ isDocumentSent }) => {
  const { updateJourneyAuditData } = useContext(JourneyContext)

  useEffect(() => {
    updateJourneyAuditData([
      {
        mode: "replace",
        data: [
          {
            name: "New document notification sent to client",
            value: "Success"
          }
        ]
      }
    ])

    return () => updateJourneyAuditData([])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDocumentSent])

  return null
}

Audit.defaultProps = {
  isDocumentSent: false
}

Audit.propTypes = {
  isDocumentSent: PropTypes.bool
}

export default Audit
